import { useContext, useEffect, useState } from "react";
import EditIcon from '../Assets/img/icon-edit-grey.svg';
import ManageOrgModal from "../Components/ManageOrgModal";
import toast from "react-hot-toast";
import { hasPermission } from "../Utils/PermissionUtils";
import { UserContext } from "../Contexts/UserContext";
import { Permission } from "../Utils/Permission";
import { orgService } from "../Services/orgService";

const ManageOrganization = () => {
    const { user, selectedOrgId } = useContext(UserContext);
    const [orgs, setOrgs] = useState([]);
    const [showManageOrgModal, setShowManageOrgModal] = useState(false);
    const [orgToEdit, setOrgToEdit] = useState(null);

    useEffect(() => {
        getOrgs();
    }, []);

    const getOrgs = () => {
        orgService.getOrgs().then(orgs => setOrgs(orgs));
    }

    const createOrg = () => {
        setOrgToEdit(null);
        setShowManageOrgModal(true);
    }

    const editOrg = (orgId) => {
        let orgToEdit = orgs?.find(o => o.orgId == orgId);
        if (orgToEdit) {
            setOrgToEdit(orgToEdit);
            setShowManageOrgModal(true);
        }
        else {
            toast.error("Something went wrong ! Try Again...")
        }
    }

    const saveOrgDetails = (org) => {
        if (isValidOrg(org)) {
            if (!!org.orgId && org.orgId > 0) {
                orgService.updateOrg(org).then(res => {
                    getOrgs();
                    setShowManageOrgModal(false);
                    toast.success("Organization Updated Successfully");
                }).catch(e =>{
                    toast.error("Organization Updated Failed. Try Again !");
                });
            }
            else {
                orgService.createOrg(org).then(res => {
                    getOrgs();
                    setShowManageOrgModal(false);
                    toast.success("Organization Created Successfully");
                }).catch(e =>{
                    toast.error("Organization Creation Failed. Try Again !");
                });
            }
        }
    }

    const isValidOrg = (org) => {
        if (!org?.name || org.name.trim() == '') {
            toast.error("Enter Valid Organization details")
            return false;
        }
        return true;
    }


    return (
        <div className="form-content">
            <div className="form-head">
                <h3>Organizations</h3> &nbsp; &nbsp;
                {
                    hasPermission(user, Permission.createOrg, selectedOrgId) &&
                    <a className="add-link" onClick={createOrg}>+ Add Organization</a>
                }
            </div>
            <div className="table-responsive">
                <table className="table table-style">
                    <thead>
                        <tr>
                            <th scope="col">Org Id</th>
                            <th scope="col">Org Name</th>
                            <th scope="col">Description</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            orgs.sort((a, b) => a.orgId - b.orgId).map((org) => {
                                return <tr>
                                            <td>{org.orgId}</td>
                                            <td>{org.name}</td>
                                            <td>{org.description}</td>
                                            <td>
                                                {
                                                    hasPermission(user, Permission.createOrg, org.orgId) &&
                                                    <a onClick={()=>editOrg(org.orgId)}>
                                                        <img src={EditIcon} />
                                                    </a>
                                                }
                                            </td>
                                        </tr>;
                            })
                        }
                    </tbody>
                </table>
            </div>
            {
                showManageOrgModal &&
                <ManageOrgModal
                    setShowManageOrgModal={setShowManageOrgModal}
                    orgToEdit={orgToEdit} 
                    saveOrgDetails={saveOrgDetails}
                />
            }
        </div>
    );
}

export default ManageOrganization;